export class UrlBuilder {
     /**
      * Replaces placeholders in the template with provided params
      * @param template - URL template with placeholders (e.g., "/users/{userId}")
      * @param params - Key-value pairs to replace placeholders
      * @returns URL with placeholders replaced
      */
     static build(template: string, params: Record<string, string | number>): string {
         return template.replace(/{(\w+)}/g, (_, key) => {
             if (!(key in params)) {
                 throw new Error(`Missing parameter: ${key}`);
             }
             return String(params[key]);
         });
     }
 
     /**
      * Appends query parameters to a URL
      * @param url - Base URL
      * @param queryParams - Key-value pairs for query parameters
      * @returns URL with query parameters appended
      */
     static addQueryParams(url: string, queryParams: Record<string, string | number>): string {
         const queryString = Object.entries(queryParams)
             .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
             .join("&");
 
         return queryString ? `${url}?${queryString}` : url;
     }
 
     /**
      * Full URL builder that supports both path and query params
      * @param template - URL template with placeholders
      * @param params - Key-value pairs to replace placeholders
      * @param queryParams - Key-value pairs for query parameters
      * @returns Fully constructed URL
      */
     static buildFullUrl(
         template: string,
         params: Record<string, string | number> = {},
         queryParams: Record<string, string | number> = {}
     ): string {
         const urlWithParams = this.build(template, params);
         return this.addQueryParams(urlWithParams, queryParams);
     }
 }
 